<div
  [id]="id"
  *ngIf="error?.message && showError"
  class="ds-form-error mt-2"
  role="alert"
  aria-atomic="true">
  <p class="mb-0 align-items-center d-flex">
    <em *ngIf="error.iconClass" class="me-2 ds-icon--big {{error.iconClass}}"></em> {{error.message}}
  </p>
</div>
